import { useContext, useRef } from "react";
import "./login.css";
import { loginCall } from "../../apiCalls";
import { AuthContext } from "../../context/AuthContex";
import { CircularProgress } from "@material-ui/core";
export default function Login() {
  const email = useRef();
  const password = useRef();

  const { user, isFetching, error, dispatch } = useContext(AuthContext);
  const PF = process.env.REACT_APP_PUBLIC_FOLDER;
  const PS = process.env.REACT_APP_PUBLIC_SERVER;

  const handleClick = (e) => {
    e.preventDefault();
    loginCall(
      { email: email.current.value, password: password.current.value },
      dispatch
    );
  };
  return (
    <div>
      <div className="auth-fluid">
        <div className="auth-fluid-form-box">
          <div className="align-items-center d-flex h-100">
            <div className="card-body">
              <div className="auth-brand text-center text-lg-start">
                <a href="index.html" className="logo-light">
                  <span>
                    <img
                      src={PS + "logo.png"}
                      alt=""
                      height="80"
                      style={{ marginTop: "-40px", marginLeft: "-60px" }}
                    />
                  </span>
                </a>
              </div>

              <h4 className="mt-0 text-center">Iniciar Sessão</h4>
              <p className="text-muted mb-4 text-center">
                Digite seu de e-mail e senha para acessar a conta.
              </p>

              <form onSubmit={handleClick}>
                <div className="mb-3">
                  <label for="emailaddress" className="form-label">
                    Email
                  </label>
                  <input
                    className="form-control"
                    type="email"
                    id="emailaddress"
                    required
                    placeholder="Digite seu e-mail"
                    ref={email}
                  />
                </div>
                <div className="mb-3">
                  <a
                    href="pages-recoverpw-2.html"
                    className="text-muted float-end"
                  >
                    <small>Esqueceu sua senha?</small>
                  </a>
                  <label for="password" className="form-label">
                    Senha
                  </label>
                  <input
                    className="form-control"
                    type="password"
                    required=""
                    id="password"
                    placeholder="Digite seu senha"
                    ref={password}
                    minLength="6"
                  />
                </div>
                <div className="mb-3">
                  <div className="form-check">
                    <input
                      type="checkbox"
                      className="form-check-input"
                      id="checkbox-signin"
                    />
                    <label className="form-check-label" for="checkbox-signin">
                      Lembrar
                    </label>
                  </div>
                </div>
                <div className="d-grid mb-0 text-center">
                  <button
                    className="btn btn-primary btn-rounded"
                    type="submit"
                    disabled={isFetching}
                  >
                    {isFetching ? (
                      <CircularProgress color="white" size="18px" />
                    ) : (
                      "Log In"
                    )}
                  </button>
                </div>

                <div className="text-center mt-4">
                  <p className="text-muted font-16">Entrar com</p>
                  <ul className="social-list list-inline mt-3">
                    <li className="list-inline-item">
                      <a
                        href="javascript: void(0);"
                        className="social-list-item border-primary text-primary"
                      >
                        <i className="mdi mdi-facebook"></i>
                      </a>
                    </li>
                    <li className="list-inline-item">
                      <a
                        href="javascript: void(0);"
                        className="social-list-item border-danger text-danger"
                      >
                        <i className="mdi mdi-google"></i>
                      </a>
                    </li>
                    <li className="list-inline-item">
                      <a
                        href="javascript: void(0);"
                        className="social-list-item border-info text-info"
                      >
                        <i className="mdi mdi-twitter"></i>
                      </a>
                    </li>
                    <li className="list-inline-item">
                      <a
                        href="javascript: void(0);"
                        className="social-list-item border-secondary text-secondary"
                      >
                        <i className="mdi mdi-github"></i>
                      </a>
                    </li>
                  </ul>
                </div>
              </form>

              <footer className="footer footer-alt">
                <p className="text-muted">
                  Não tem conta?{" "}
                  <a href={PF + "registo"} className="text-muted ms-1">
                    <b>Registrar-se</b>
                  </a>
                </p>
              </footer>
            </div>
          </div>
        </div>

        <div className="auth-fluid-right text-center">
          <div className="auth-user-testimonial">
            <h2 className="mb-3">EmaInvest</h2>
            <p className="lead">
              <i className="mdi mdi-format-quote-open"></i> Se você pode
              realmente contar seu dinheiro, então você não é um homem rico.{" "}
              <i className="mdi mdi-format-quote-close"></i>
            </p>
            <p>- J. Paul Getty</p>
          </div>
        </div>
      </div>
    </div>
  );
}
